import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import { useFilters } from 'components/Dashboard/Filters/FiltersContext';
import useGeneralRequestProperties from 'components/Dashboard/hooks/useGeneralRequestProperties';
import { useResearchItemsUrl } from 'components/Dashboard/Navigation/NavPages';
import createSectionViewStoreProperty from 'components/Dashboard/ParliamentLive/createSectionViewStoreProperty';
import Loading from 'components/Login/Loading';
import { store } from 'components/Store';
import ConfigData from 'config/ConfigData';
import { useContext, useLayoutEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import getAppSite from 'utils/getAppSite';

const MonitorPage = () => {
  const globalState = useContext(store);
  const { dispatch, state } = globalState;
  const { activePlan, keywordsLists } = state ?? {};
  const { enableLiveTranscription } = activePlan ?? {};

  const navigate = useNavigate();

  const { createRequestProperties } = useGeneralRequestProperties({ sectionName: 'ParliamentLive' });
  const { generalApiCall } = useGeneralApiCall();
  const { monitorUrl } = useResearchItemsUrl();
  const { clearContentFilters } = useFilters();

  const notShowDashboardFlow = async ({ source, priorityUpdatesResult }) => {
    const searchQuery = monitorUrl?.replace('/monitor-inbox', '');
    if (!enableLiveTranscription || getAppSite() === 'usa') {
      //AE: It's quite possible that on change of location.pathname it doesn't detect the pathname change immediately due to the way this component is rendered on Dashboard/index.js. On that file is the explanation of why was necessary to render in that way and not following the react-router pattern. SetTimeOut seems to fix that temporary issue, on the other redirections it works correctly because we always have an API call.
      setTimeout(() => {
        navigate({
          pathname: `/monitor-inbox/key-updates`,
          search: searchQuery,
        });
      }, 100);
    } else {
      try {
        const keywordsListsToUse = keywordsLists.filter((topic) => topic.id && topic.myState === 'Enabled');
        if (keywordsListsToUse?.length > 0) {
          const { url, requestProperties } = createRequestProperties({});
          const liveResults = await generalApiCall({
            pathname: url,
            requestProperties,
            method: 'post',
            needsAuthentication: true,
            notShowErrorMessage: true,
            requestSource: source,
          });
          if (!!liveResults) {
            dispatch({ type: 'MODIFY_SECTION', parameter: 'sectionsView', value: createSectionViewStoreProperty() });
            navigate({
              pathname: `/monitor-inbox/${liveResults?.hits?.length > 0 ? 'parliament-live' : 'key-updates'}`,
              search: searchQuery,
            });
          }
        } else {
          navigate({
            pathname: `/monitor-inbox/${ConfigData?.monitorInboxInitialPage ?? 'key-updates'}`,
            search: searchQuery,
          });
        }
      } catch (error) {}
    }
  };

  const initialValidation = useRef(null);
  initialValidation.current = async (source) => {
    clearContentFilters();
    notShowDashboardFlow(source);
  };

  // AE: It's quite possible that on change of location.pathname it doesn't detect the pathname change immediately due to the way this component is rendered on Dashboard/index.js.
  // On that file is the explanation of why was necessary to render in that way and not following the react-router pattern.
  // useLayoutEffect seems to fix that temporary issue,
  // on the other redirections it works correctly because we always have an API call.
  useLayoutEffect(() => {
    const source = new AbortController();
    initialValidation.current(source);
    return () => {
      source.abort('Monitor cancelled by the user');
    };
  }, []);

  return <Loading />;
};

export default MonitorPage;
